// THE STATE ROW (Neila 2026-10-12 "could we segment, by State too?"; the medrec console's state-breakout shape, 10-13): a row of toggle
// buttons at the start of a list's filter bar, "All" first, then CA, then every other state by its count high to low, "No state" last.
// Salesforce keeps the case's state as "CA California" (litify_pm__Matter_State__c), so a state's key is its first word ("CA"), as the rows
// show it. The choice lives in the page address (?state=CA, ?state=none); All is no parameter, and shows the list exactly as before.
/** The key for a case with no state. */
export const NO_STATE = 'none';
/** A case's state key: "CA California" -> "CA"; blank -> NO_STATE. */
export function stateKeyOf(state) {
    const first = String(state ?? '').trim().split(/\s+/)[0] ?? '';
    return first ? first.toUpperCase() : NO_STATE;
}
/** The address's ?state= value as a choice: a state key, NO_STATE, or null (All) for anything else. */
export function stateChoiceOf(param) {
    const v = String(param ?? '').trim();
    if (v.toLowerCase() === NO_STATE)
        return NO_STATE;
    return /^[A-Za-z]{2,3}$/.test(v) ? v.toUpperCase() : null;
}
/** Whether a case is in the chosen state (null = All: every case). */
export function inState(state, choice) {
    return choice === null || stateKeyOf(state) === choice;
}
/** The row's state buttons (after All), from the states of the rows the list would show with no narrowing: CA first, then every other state
 *  by count high to low (ties A to Z), No state last. A state with no rows is left out unless it is the chosen one (shown with 0, so the
 *  person sees why the list is empty). */
export function stateButtons(states, choice) {
    const counts = new Map();
    const names = new Map();
    for (const s of states) {
        const k = stateKeyOf(s);
        counts.set(k, (counts.get(k) ?? 0) + 1);
        if (k !== NO_STATE && !names.has(k))
            names.set(k, String(s).trim());
    }
    if (choice !== null && !counts.has(choice))
        counts.set(choice, 0);
    const rank = (k) => (k === 'CA' ? 0 : k === NO_STATE ? 2 : 1);
    return [...counts.entries()]
        .sort(([a, x], [b, y]) => rank(a) - rank(b) || y - x || a.localeCompare(b))
        .map(([key, count]) => ({ key, count, label: key === NO_STATE ? 'No state' : key, title: key === NO_STATE ? 'Cases with no state in Salesforce' : names.get(key) ?? key }));
}
//# sourceMappingURL=states.js.map